export type AgeRangeUnit = 'years' | 'months';

export const AGE_RANGE_BOUNDS: Record<AgeRangeUnit, { min: number; max: number }> = {
  years: { min: 0, max: 12 },
  months: { min: 0, max: 36 },
};
